import { render, staticRenderFns } from "./inProgressChallenges.vue?vue&type=template&id=c9360018&scoped=true"
import script from "./inProgressChallenges.vue?vue&type=script&lang=js"
export * from "./inProgressChallenges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9360018",
  null
  
)

export default component.exports